import { DeheadingReportingTypeEnum, OperationTypeEnum, ProductionProcessTypeEnum, ShiftsEnum } from "@gtpl/shared-models/common-models";
import { PeelingRateBasedEnum } from "@gtpl/shared-models/masters";

export class OperationReportingReq{
    operation : OperationTypeEnum;
    prevOperation : OperationTypeEnum
    batchNumber : string
    reportedQty : number
    shift : ShiftsEnum
    workStation: number
    count: number
    reportingType : DeheadingReportingTypeEnum
    product : string
    plantId : number
    createdUser: string
    grade?:string
    processType?:ProductionProcessTypeEnum
    boxes?:number
    date?:any
    billNo?:string
    contractorId?:number
    scopeOfWork?:string
    peelingRate?: number
    noOfPersons?:number     // no of persons worked at a workstation for peeling    
    workersInfo?:WorkersInfo[]
    soakTime?:number
    soakStyle?:string
    deheadingRate?:number
    reason?:string    //  Deheading rate per kg change reason
    outputQuantity?:number
    peelingPriceBasedOn?:PeelingRateBasedEnum
    year?:number
    avgQty ?: number
    avgWage ?: number
    isRRP?:boolean
    rejectionFrom ?: string
    prevOperProduct?: string
     
    constructor(operation : OperationTypeEnum,prevOperation : OperationTypeEnum,batchNumber : string,reportedQty : number,shift : ShiftsEnum,workStation: number,count: number,reportingType : DeheadingReportingTypeEnum,product : string,plantId : number,createdUser: string,grade?:string,processType?:ProductionProcessTypeEnum,boxes?:number,date?:any,billNo?:string,contractorId?:number,scopeOfWork?:string,peelingRate?: number,noOfPersons?:number,workersInfo?:WorkersInfo[],soakTime?:number,soakStyle?:string,deheadingRate?:number,reason?:string,outputQuantity?:number,peelingPriceBasedOn?:PeelingRateBasedEnum,year?:number,avgQty ?: number,avgWage ?: number,isRRP?:boolean,rejectionFrom ?: string,prevOperProduct?: string){
    this.operation = operation 
    this.prevOperation = prevOperation 
    this.batchNumber = batchNumber 
    this.reportedQty = reportedQty 
    this.shift = shift 
    this.workStation= workStation
    this.count= count
    this.reportingType = reportingType 
    this.product = product 
    this.plantId = plantId
    this.createdUser = createdUser
    this.grade = grade
    this.processType = processType
    this.boxes = boxes
    this.date = date
    this.billNo = billNo
    this.contractorId = contractorId
    this.scopeOfWork = scopeOfWork
    this.peelingRate = peelingRate
    this.noOfPersons = noOfPersons
    this.workersInfo = workersInfo
    this.soakTime = soakTime
    this.soakStyle = soakStyle
    this.deheadingRate = deheadingRate
    this.reason = reason
    this.outputQuantity = outputQuantity
    this.peelingPriceBasedOn = peelingPriceBasedOn
    this.year = year
    this.avgQty = avgQty
    this.avgWage = avgWage
    this.isRRP = isRRP
    this.rejectionFrom = rejectionFrom
    this.prevOperProduct = prevOperProduct
    }
}

export class WorkersInfo{
    workerId : number
    workerCode : string
    workerName : string
    contractorId : number
    contractorName : string
    village : string
    transportCost : number
    transportation : string
    opeartion : string


    constructor(workerId : number,workerCode : string,workerName : string,contractorId : number,contractorName : string,village : string,transportCost : number,transportation:string,opeartion : string){
    this.workerId = workerId 
    this.workerCode = workerCode 
    this.workerName = workerName 
    this.contractorId = contractorId 
    this.contractorName = contractorName 
    this.village = village 
    this.transportCost = transportCost 
    this.transportation =transportation
    this.opeartion = opeartion

    }

}